import React from "react";

export interface FormBarEntry {
  gwNumber: number;
  gwName: string;
  score: number;
}

interface Props {
  history: FormBarEntry[];
  compact?: boolean; // leaderboard row: no labels, smaller
}

export default function FormBar({ history, compact = false }: Props) {
  if (history.length === 0) {
    return <span style={{ color: "var(--color-text-dim)", fontSize: "0.75rem" }}>—</span>;
  }

  const maxScore = Math.max(...history.map((h) => h.score), 1);
  const barW = compact ? 6 : 10;
  const barGap = compact ? 2 : 3;
  const maxH = compact ? 20 : 32;
  const totalW = history.length * barW + (history.length - 1) * barGap;

  return (
    <div
      title={history.map((h) => `${h.gwName}: ${h.score}`).join(" · ")}
      style={{
        display: "inline-flex",
        alignItems: "flex-end",
        gap: barGap,
        height: maxH,
        width: totalW,
        flexShrink: 0,
      }}
    >
      {history.map((h) => {
        const isZero = h.score === 0;
        const height = isZero ? 2 : Math.max(Math.round((h.score / maxScore) * maxH), 3);
        return (
          <div
            key={h.gwNumber}
            style={{
              width: barW,
              height,
              borderRadius: isZero ? 1 : 2,
              background: isZero ? "var(--color-text-dim)" : "var(--color-accent)",
              opacity: isZero ? 0.4 : 1,
              flexShrink: 0,
            }}
          />
        );
      })}
    </div>
  );
}
